import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentSymbol'
})
export class PercentSymbolPipe implements PipeTransform {
  
transform(value: number | string): string {
   return `${value} %`;
}

}
